import React from "react";
import { connect } from "react-redux";
import { Div } from "components/Base";
import * as R from "ramda";
import { BigOutlineButton } from "components/Base";
import { noop } from "utils/General";
import { actions, getters } from "Portal/NewPortal/PortalHome/model";
import { getEnabledSectionsMenu } from "../../selectors";

const decorate = connect(
  state => ({
    styles: getters.styles(state),
    categories: getEnabledSectionsMenu(state)
  }),
  {
    onCategoryClick: actions.setSelectedCategory,
    navigateTo: actions.navigateTo
  }
);

const MenuButtons = ({
  selectedCategory,
  categories,
  isHomeSection = false,
  styles,
  navigateTo = noop
}) => {
  return (
    <Div
      bt={isHomeSection ? 1 : 0}
      bb={1}
      br={0}
      bl={0}
      bc={"#E7E6EA"}
      style={{
        gap: "16px",
        padding: "24px 0",
        width: "100%"
      }}
      display="row.center.center"
    >
      {R.map(
        ({
          id,
          icon,
          name,
          disabled = false,
          shouldScrollToSection = false
        }) => {
          const isActive = id === selectedCategory;
          if (disabled) {
            return null;
          }
          return (
            <BigOutlineButton
              key={id}
              hover={true}
              style={
                styles.accent_color
                  ? {
                      background: isActive ? "#fafafa" : undefined,
                      color: isActive ? styles.accent_color : "#494949",
                      borderColor: isActive ? styles.accent_color : "#E7E6EA",
                      borderWidth: "1px"
                    }
                  : {
                      background: isActive ? "#F1F3FE" : undefined,
                      color: isActive ? "#4263EB" : "#494949",
                      borderColor: isActive ? "#4263EB" : "#E7E6EA",
                      borderWidth: "1px"
                    }
              }
              LeftIcon={() => (
                <i
                  className={`material-icons-outlined ${icon}`}
                  style={{
                    fontSize: "16px",
                    marginRight: "6px",
                    color: isActive
                      ? styles.accent_color
                        ? styles.accent_color
                        : "#4263EB"
                      : "#494949"
                  }}
                >
                  {icon}
                </i>
              )}
              onClick={() => {
                navigateTo({ id, shouldScrollToSection });
              }}
            >
              {name}
            </BigOutlineButton>
          );
        },
        categories
      )}
    </Div>
  );
};
export default decorate(MenuButtons);
